export default {"src":"/_next/static/media/1-h.3444abe0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};